import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Countries, Country } from '../../../source/modules/login/countries';
import { Profile } from '../../../source/modules/player/profile';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import * as cashierActions from '../../../source/appstates/cashierstates/cashierActions'
import * as loginActions from '../../../source/appstates/loginstates/loginActions'
import * as playerActions from '../../../source/appstates/playerstates/playerActions'
import * as appState from '../../../source/appstates/appState'
import { ProfileState } from '../../../source/appstates/playerstates/playerState';
import { TranslateModule } from '@ngx-translate/core';
import { Console } from 'console';
declare var $: any;
function showupdateModal() {
  $("#update").modal("show");
}
function hideUpdateModal() {
  $("#update").modal("hide");
}
@Component({
  selector: 'app-update-porfile',
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule],
  templateUrl: './update-porfile.component.html',
  styleUrl: './update-porfile.component.css'
})
export class UpdatePorfileComponent implements OnInit, OnDestroy {
  @Input() fromProfileState!: string;
  @Output() close = new EventEmitter<void>();

  errorMessage: string='';
  ErrorMessageS: string='';
  private storeSub!: Subscription;
  private closeSub!: Subscription;
  updateForm!: FormGroup;
  updatePassword!: FormGroup;
  updatepwdRespPopup: boolean = false;
  updatePasswordOne: boolean = false;
  isHide: boolean = false;
  countries!: Countries;
  country: Country[]=[];
  registerRespPopup: boolean = false;
  updateProfileState: string = "UPDATEFORM";
  updatePasswordState: string = "UPDATEPASSWORD";
  profileFormState: string='';
  fieldTextType: boolean = true;
  changeeye: boolean = true;
  profile!: Profile;  
  viewpass() {
    this.fieldTextType = !this.fieldTextType;
    this.changeeye = !this.changeeye;
  }
  constructor(private store: Store<appState.AppState>, private router: Router) {

    // this.profileFormState = this.updateProfileState;
  }

  ngOnInit() {

    this.store.dispatch(new playerActions.ResetState());

    this.updateForm = new FormGroup({
      "nickname": new FormControl('', Validators.required),
      "email": new FormControl(null, [Validators.required, Validators.email]),
      "firstName": new FormControl('', Validators.required),
      "lastName": new FormControl('', Validators.required),
      "address": new FormGroup({
        "city": new FormControl('', Validators.required),
        "phone": new FormControl('', Validators.required),
        "country": new FormControl('', Validators.required),
      }),
    })

    this.updatePassword = new FormGroup({
      "oldPassword": new FormControl('',[Validators.required, Validators.minLength(6),Validators.maxLength(15),Validators.pattern(/^\S*$/)]),
      "newPassword": new FormControl('', [Validators.required, Validators.minLength(6),Validators.maxLength(15),Validators.pattern(/^\S*$/)])
    }) 
    this.storeSub = this.store.select("playerState").subscribe(
      (playerState: ProfileState) => {
        if (playerState.profileUpdateResponse) {
          const response = playerState.profileUpdateResponse as { success: boolean; description?: string };
          // hideUpdateModal()
           
          if (response.success === false) {
            // this.errorMessage = 'Invalid Old Password!'
            if (response.description == 'Invalid argument') {
              this.errorMessage = 'INVALID_OLD_PASSWORD'
            } else if(response["description"] == "Old Password and  New Password Cannot be the same"){
                this.errorMessage = "OLD_PASSWORD_AND_NEW_PASSWORD_CANNOT_BE_THE_SAME"
              }else{
                this.errorMessage = response.description || "";
              console.log(this.errorMessage)
            }
            setTimeout(()=>{
              this.errorMessage='';
            }, 3000)
          }        
          if (response["success"] === true) {
            this.ErrorMessageS = "YOUR_PASSWORD_UPDATED_SUCCESSFULLY.PLEASE_LOGIN_WITH_NEW_PASSWORD.";
            this.updatePasswordOne = true;
            this.closeModel();
            // window.location.reload();
          }
        }
        if (playerState.profileUpdateFail) {
          this.errorMessage = playerState.profileUpdateFail.message;
        }
        if (playerState.profile) {
          this.profile = playerState.profile;
          if (this.profile.nickname) {
            (<FormControl>this.updateForm.get('nickname')).setValue(this.profile.nickname);
          }
          if (this.profile.email) {
            (<FormControl>this.updateForm.get('email')).setValue(this.profile.email);
          }
          if (this.profile.firstName) {
            (<FormControl>this.updateForm.get('firstName')).setValue(this.profile.firstName);
          }
          if (this.profile.lastName) {
            (<FormControl>this.updateForm.get('lastName')).setValue(this.profile.lastName);
          }
          if (this.profile.address) {
            if (this.profile.address.city) {
              (<FormControl>this.updateForm.get('address')).get("city")?.setValue(this.profile.address.city);
            }
            if (this.profile.address.phone) {
              (<FormControl>this.updateForm.get('address')).get("phone")?.setValue(this.profile.address.phone);
            }
            if (this.profile.address.country) {
              (<FormControl>this.updateForm.get('address')).get("country")?.setValue(this.profile.address.country);
            }
          }
        }
      }
    )
    // this.store.dispatch(new loginActions.RegisterGetCountry());
    this.store.dispatch(new playerActions.PlayerGetProfile());

    if (this.fromProfileState) {
      console.log(this.fromProfileState);
      this.profileFormState = this.fromProfileState;
    }
    this.changeFormState(this.profileFormState);
    showupdateModal();
    $("#update").on('hidden.bs.modal',  () => {
      this.onClose();
    } );
    var doc = document;
    const handleKeyUpforEnter = (evt:any) => {
      if (this.updatePasswordState == 'UPDATEPASSWORD') {

      if (evt.key == "Enter" && this.updatePassword.valid){

        if(this.updatePassword.controls['oldPassword'].status == 'VALID' && this.updatePassword.controls['newPassword'].status == 'VALID'){
     
          this.onUpdatePasswordSubmit() ;

        }
        //Your method or code
      }
      }
    }
    doc.addEventListener("keyup", handleKeyUpforEnter);
  }
  changeFormState(state:any) {
    // this.store.dispatch(new loginActions.ResetState());
    this.profileFormState = state;
  }
  onInputFocus() {

  }
  onFormSubmit() {
    this.store.dispatch(new playerActions.PlayerUpdateProfile(this.updateForm.value));
  }
  onUpdatePasswordSubmit() {
    this.errorMessage = '';
    this.store.dispatch(new playerActions.PlayerUpdatePassword(this.updatePassword.value));
    // this.closeSub.unsubscribe();


  }
  onClose() {
    console.log("update profile close popup");
    this.close.emit();
  }
  ngOnDestroy() {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
  }
  updatepwdsuccessPopClose() {
    this.store.dispatch(new loginActions.LogoutStart());
    this.updatePasswordOne = false;
    this.errorMessage = '';
  }

  showErrorPass() {
    this.isHide = !this.isHide;
  }
  // casinogamessuccessPopClose(){
  //   this.registerRespPopup = true;
  // }
  // closeModel() { alert("test"), document.getElementById('update').setAttribute('update-modal', 'hide'); }

  closeModel() {
    let pan = (<HTMLInputElement>document.getElementById('update'));
    pan.style.display = "none";
  }
  newpasswordValid(event:any) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k >= 33 && k <= 47 || k >= 60 && k <= 64 || (k >= 48 && k <= 57) || k >= 91 && k <= 96 || k >= 123 && k <= 126);
  }
  oldpasswordValid(event:any) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k >= 33 && k <= 47 || k >= 60 && k <= 64 || (k >= 48 && k <= 57) || k >= 91 && k <= 96 || k >= 123 && k <= 126);
  }
}

